import { BlocksIconLanguage } from 'blocks-nextjs/blocks-web-components/components/icon/icons/language';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconLanguage = createComponent({ react: React, tagName: 'cat-icon-language', elementClass: BlocksIconLanguage });
